/**
 * THE DRAWINGS, COPIED VERBATIM (redesign register A8, O5; brief FE-FOUNDATION section 2).
 *
 * Generated from `crm-design/design-system/symbols/<name>.svg` (outside the repository) by a
 * script that read each file's viewBox and path elements: our own drawings of Apple's SF
 * Symbols shapes, measured against Apple's rendering at IoU 0.90 or above (`manifest.json`),
 * never redrawn here and never the `reference/` bitmaps. Every path is `currentColor`; the
 * marks inside the filled symbols are cut out by `evenodd`, so they show what is behind them,
 * as Apple's `.fill` symbols do (README "Construction").
 *
 * `width` and `height` are the drawing's own layout box in the README's common scale
 * (24 units = the circle family), which is what the sizing rule multiplies.
 */
export interface SymbolPath {
  readonly d: string;
  /** `fill` paths are filled shapes; `stroke` paths are outlines with a width in viewBox units. */
  readonly kind: 'fill' | 'fill-evenodd' | 'stroke';
  readonly strokeWidth?: number;
}

export interface SymbolDrawing {
  /** The file it was copied from, for a reader who wants to compare. */
  readonly source: string;
  readonly width: number;
  readonly height: number;
  readonly paths: readonly SymbolPath[];
}

export const DRAWINGS = {
  actNow: {
    source: 'exclamationmark-octagon-fill.svg',
    width: 25.76,
    height: 23.36,
    paths: [
      {
        d: 'M7.454 2.752A2.8 2.8 0 0 1 9.525 1.836L16.127 1.836A2.8 2.8 0 0 1 18.198 2.752L22.366 7.336A2.8 2.8 0 0 1 23.095 9.22L23.095 14.22A2.8 2.8 0 0 1 22.366 16.103L18.203 20.682A2.8 2.8 0 0 1 16.132 21.599L9.521 21.599A2.8 2.8 0 0 1 7.45 20.682L3.287 16.103A2.8 2.8 0 0 1 2.559 14.22L2.559 9.22A2.8 2.8 0 0 1 3.287 7.336ZM11.861 7.377A0.95 0.95 0 0 1 13.759 7.377L13.609 12.811A0.799 0.799 0 0 1 12.01 12.811ZM11.707 15.852A1.11 1.083 0 0 1 12.817 14.769A1.11 1.083 0 0 1 13.928 15.852A1.11 1.083 0 0 1 12.817 16.936A1.11 1.083 0 0 1 11.707 15.852Z',
        kind: 'fill-evenodd',
      },
    ],
  },
  late: {
    source: 'clock-fill.svg',
    width: 24,
    height: 24,
    paths: [
      {
        d: 'M1.768 12.053A10.189 10.189 0 0 1 11.957 1.864A10.189 10.189 0 0 1 22.147 12.053A10.189 10.189 0 0 1 11.957 22.242A10.189 10.189 0 0 1 1.768 12.053ZM11.246 5.693L11.246 11.724L6.754 11.724A0.698 0.698 0 0 0 6.754 13.121L11.943 13.121A0.698 0.698 0 0 0 12.641 12.422L12.641 5.693A0.698 0.698 0 0 0 11.246 5.693Z',
        kind: 'fill-evenodd',
      },
    ],
  },
  watch: {
    source: 'exclamationmark-triangle-fill.svg',
    width: 25.12,
    height: 22.56,
    paths: [
      {
        d: 'M10.256 3.126A2.655 2.655 0 0 1 14.861 3.126L22.674 16.731A2.714 2.714 0 0 1 20.32 20.797L4.797 20.797A2.714 2.714 0 0 1 2.444 16.731ZM11.616 7.885A0.929 0.929 0 0 1 13.473 7.885L13.352 13.31A0.807 0.807 0 0 1 11.737 13.31ZM11.441 16.388A1.109 1.06 0 0 1 12.55 15.328A1.109 1.06 0 0 1 13.659 16.388A1.109 1.06 0 0 1 12.55 17.45A1.109 1.06 0 0 1 11.441 16.388Z',
        kind: 'fill-evenodd',
      },
    ],
  },
  done: {
    source: 'checkmark-circle-fill.svg',
    width: 24,
    height: 24,
    paths: [
      {
        d: 'M1.768 12.053A10.189 10.189 0 0 1 11.957 1.864A10.189 10.189 0 0 1 22.147 12.053A10.189 10.189 0 0 1 11.957 22.242A10.189 10.189 0 0 1 1.768 12.053ZM7.378 13.215L10.221 16.817A0.807 0.807 0 0 0 11.539 16.745L16.489 8.846A0.807 0.807 0 0 0 15.12 7.988L10.779 14.917L8.647 12.215A0.807 0.807 0 0 0 7.378 13.215Z',
        kind: 'fill-evenodd',
      },
    ],
  },
  waiting: {
    source: 'person-badge-clock-fill.svg',
    width: 25.92,
    height: 26.56,
    paths: [
      {
        d: 'M19.25 13.29C18.41 13.29 17.56 13.59 16.85 14.02C13.39 16.11 13.65 21.2 17.28 22.93C17.94 23.25 18.67 23.43 19.4 23.43C19.5 23.43 19.61 23.44 19.71 23.43C19.93 23.4 20.16 23.39 20.38 23.35C20.76 23.29 21.18 23.15 21.53 22.98C22.42 22.53 23.19 21.89 23.73 21.05C23.85 20.86 23.93 20.65 24.04 20.47C24.22 20.17 24.34 19.76 24.4 19.42C24.48 18.94 24.56 18.46 24.5 17.97C24.43 17.44 24.37 16.91 24.13 16.42C23.83 15.81 23.5 15.15 22.96 14.71C22.8 14.58 22.66 14.43 22.49 14.31C21.87 13.83 21.12 13.5 20.35 13.36C19.99 13.3 19.62 13.29 19.25 13.29Z M19.42 14.81C19.69 14.72 20.01 14.96 20.1 15.21C20.2 15.49 20.14 16.71 20.14 17.08C20.14 17.54 20.17 18 20.14 18.46C20.13 18.57 20.12 18.68 20.07 18.78C19.86 19.22 19.35 19.14 18.94 19.14C18.65 19.14 18.36 19.14 18.08 19.14C17.72 19.14 17.08 19.21 16.78 19.06C16.33 18.84 16.41 18.2 16.8 17.97C17.12 17.78 18.77 18 18.87 17.85C18.93 17.76 18.89 17.56 18.89 17.45C18.89 17.06 18.83 15.45 18.92 15.2C18.99 15.01 19.21 14.81 19.42 14.81Z M10.42 12.39C10 12.39 9.58 12.47 9.17 12.53C7.32 12.82 5.54 13.7 4.22 15.04C3.95 15.31 3.68 15.61 3.48 15.94C3.4 16.07 3.29 16.19 3.22 16.33C2.93 16.92 2.67 17.44 2.59 18.1C2.52 18.69 2.62 19.3 3.2 19.6C3.42 19.72 3.69 19.79 3.94 19.82C4.37 19.86 4.81 19.83 5.24 19.83C6.06 19.83 6.88 19.83 7.7 19.83C8.92 19.83 10.13 19.83 11.34 19.83C11.9 19.83 12.47 19.86 13.03 19.83C13.08 19.83 13.14 19.83 13.16 19.78C13.18 19.7 13.05 19.04 13.03 18.91C13 18.72 13.01 18.49 13.01 18.29C13.03 17.28 13.28 16.28 13.75 15.39C14.02 14.87 14.36 14.4 14.75 13.97C14.82 13.9 15.33 13.43 15.33 13.4C15.34 13.32 15.14 13.26 15.08 13.23C14.8 13.13 14.53 13 14.25 12.9C13.55 12.67 12.82 12.52 12.09 12.43C11.84 12.4 11.57 12.42 11.32 12.38C11.03 12.34 10.71 12.39 10.42 12.39Z M10.75 1.89C10.06 1.89 9.36 2.19 8.8 2.57C7.57 3.42 6.93 4.91 6.98 6.38C6.99 6.66 7.04 6.93 7.09 7.21C7.13 7.47 7.21 7.77 7.33 8.01C7.54 8.44 7.77 8.83 8.07 9.21C8.37 9.59 8.78 9.86 9.19 10.11C9.87 10.52 10.76 10.67 11.54 10.54C12.17 10.43 12.77 10.16 13.26 9.77C15.85 7.72 15.43 3.25 12.21 2.1C11.91 1.99 11.04 1.79 10.75 1.89Z',
        kind: 'fill-evenodd',
      },
    ],
  },
  ring: {
    source: 'circle.svg',
    width: 24,
    height: 24,
    paths: [
      {
        d: 'M2.611 12.053A9.346 9.346 0 0 1 11.957 2.707A9.346 9.346 0 0 1 21.304 12.053A9.346 9.346 0 0 1 11.957 21.399A9.346 9.346 0 0 1 2.611 12.053Z',
        kind: 'stroke',
        strokeWidth: 1.695,
      },
    ],
  },
  waived: {
    source: 'minus-circle.svg',
    width: 24,
    height: 24,
    paths: [
      {
        d: 'M2.615 12.053A9.342 9.342 0 0 1 11.957 2.711A9.342 9.342 0 0 1 21.3 12.053A9.342 9.342 0 0 1 11.957 21.395A9.342 9.342 0 0 1 2.615 12.053Z',
        kind: 'stroke',
        strokeWidth: 1.694,
      },
      { d: 'M7.939 12.053H15.976', kind: 'stroke', strokeWidth: 1.697 },
    ],
  },
  blocked: {
    source: 'circle-dashed.svg',
    width: 24,
    height: 24,
    paths: [
      {
        d: 'M21.613 8.798A10.19 10.19 0 0 1 21.613 15.308L20.044 14.658A8.496 8.496 0 0 0 20.044 9.448ZM21.087 16.578A10.19 10.19 0 0 1 16.483 21.182L15.833 19.613A8.496 8.496 0 0 0 19.518 15.928ZM15.212 21.708A10.19 10.19 0 0 1 8.702 21.708L9.352 20.139A8.496 8.496 0 0 0 14.562 20.139ZM7.432 21.182A10.19 10.19 0 0 1 2.828 16.578L4.397 15.928A8.496 8.496 0 0 0 8.082 19.613ZM2.302 15.308A10.19 10.19 0 0 1 2.302 8.798L3.871 9.448A8.496 8.496 0 0 0 3.871 14.658ZM2.828 7.527A10.19 10.19 0 0 1 7.432 2.923L8.082 4.493A8.496 8.496 0 0 0 4.397 8.177ZM8.702 2.397A10.19 10.19 0 0 1 15.212 2.397L14.562 3.966A8.496 8.496 0 0 0 9.352 3.966ZM16.483 2.923A10.19 10.19 0 0 1 21.087 7.527L19.518 8.177A8.496 8.496 0 0 0 15.833 4.493Z',
        kind: 'fill',
      },
    ],
  },
} as const satisfies Record<string, SymbolDrawing>;

export type DrawingName = keyof typeof DRAWINGS;
